import React, { InputHTMLAttributes } from 'react';
import { useFormikContext } from 'formik';
import { ExtraStyleType, FieldCustom } from '../FieldCustom/FieldCustom';
import { FIELDS_REGEX } from 'settings/regex';
import { replacePhoneNumberWithSpace } from 'services/formatter';

type TextFieldCustomProps = {
  extraStyle?: ExtraStyleType;
  label?: string;
  name: string;
  validation?: keyof typeof FIELDS_REGEX;
  type?: string | 'text';
  isErrorVisible?: boolean;
  uppercase?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export default function TextFieldCustom({
  extraStyle,
  label,
  name,
  validation,
  type = 'text',
  isErrorVisible,
  uppercase,
  onChange,
  ...props
}: React.PropsWithChildren<TextFieldCustomProps>): JSX.Element {
  const { setFieldValue } = useFormikContext();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (uppercase) {
      const value = e.target.value.toUpperCase();
      setFieldValue(name, value);
    } else if (validation && FIELDS_REGEX[validation].test(e.target.value)) {
      setFieldValue(name, e.target.value);
      if (type === 'tel') {
        setFieldValue(name, replacePhoneNumberWithSpace(e.target.value));
      }
    }

    if (typeof onChange === 'function') {
      onChange(e);
    }
  }

  return (
    <FieldCustom
      as="input"
      extraStyle={extraStyle}
      label={label}
      name={name}
      {...((validation || uppercase) && { onChange: handleChange })}
      type={type}
      isErrorVisible={isErrorVisible}
      {...props}
    />
  );
}
